export class LandingRoutes {
	public static readonly RedirectRoute = 'landing';
	public static readonly DefaultRoute = 'dashboard';
	public static readonly MobileRoute = 'mobile';
	public static readonly ContactMethodRequired = 'useraccount/registration/account-setup';
	public static readonly ContactMethodUpdate = 'useraccount/registration/account-update';
}
